import React from "react";

const DocsViewer = ({ docUrl }) => {
  return (
    <div className="w-full h-full overflow-auto">
      <iframe
        src={docUrl}
        width="100%"
        height="100%"
        title="Document Preview"
      ></iframe>
    </div>
  );
};

export default DocsViewer;
